import {
  OnboardingMultiDocument,
  OracleOnboardingMultiDocumentSectionKey,
  isOracleOnboardingMultiDocumentSectionKey
} from '@blisspointmedia/bpm-types/dist/ClientOracleOnboarding';
import { FetchError } from '@src/utils/fetch-error';
import { ONBOARDING_SECTIONS } from './oracle-onboarding-constants';

type OnboardingSectionEntry = (typeof ONBOARDING_SECTIONS)[number];
export type MultiDocumentSectionEntry = Extract<
  OnboardingSectionEntry,
  { key: OracleOnboardingMultiDocumentSectionKey }
>;

export const isMultiDocumentSection = (
  section: OnboardingSectionEntry
): section is MultiDocumentSectionEntry => isOracleOnboardingMultiDocumentSectionKey(section.key);

export interface UploadedFile {
  fileId: string;
  fileName: string;
}

export interface LastUpload {
  file: File;
  uploaded: UploadedFile;
}

// A retry of the same file reuses its upload, so a save whose response was lost is not saved twice.
export const reusableUpload = (last: LastUpload | null, file: File): UploadedFile | undefined =>
  last?.file === file ? last.uploaded : undefined;

// A refusal from the server clears the upload. A server error or a lost response keeps it.
export const keepsUploadAfter = (error: unknown): boolean =>
  !(error instanceof FetchError && error.status < 500);

// The modal's checks, in the order the fields appear. Null when the form can be sent.
export const validateMultiDocumentForm = ({
  hasFile,
  note,
  noteRequiredMessage
}: {
  hasFile: boolean;
  note: string;
  noteRequiredMessage: string;
}): string | null => {
  if (!hasFile) {
    return 'Add a PDF.';
  }
  if (!note.trim()) {
    return noteRequiredMessage;
  }
  return null;
};

export const latestUpdate = (
  documents: readonly OnboardingMultiDocument[]
): OnboardingMultiDocument | undefined =>
  documents.reduce<OnboardingMultiDocument | undefined>(
    (latest, doc) => (!latest || doc.updatedAt > latest.updatedAt ? doc : latest),
    undefined
  );
